'use client';

import { type FC, useEffect } from 'react';
import type { GameV1 } from '@/api/games';
import { GamesGridStatic } from '@/components/GamesGrid';
import type {
  ISearchResultAppearanceEventData,
  TSearchResultGameOpenType,
} from '@/modules/googleAnalytics/events/searchGamesEvents';
import { perGamesGridChunk } from '../../helpers';
import type { ISearchGridOptions } from '../ResultWithSimilar';

interface ISearchResultProps {
  games: GameV1[];
  totalCount?: number;
  loading: boolean;
  gridOptions: ISearchGridOptions;
  handleClickShowMore: () => void;
  handleSearchGameClick: (
    game: GameV1,
    type: TSearchResultGameOpenType
  ) => void;
  sendSearchResultAppearance: (
    params: Partial<ISearchResultAppearanceEventData>
  ) => void;
}

export const SearchResult: FC<ISearchResultProps> = ({
  games,
  totalCount,
  loading,
  gridOptions,
  handleClickShowMore,
  handleSearchGameClick,
  sendSearchResultAppearance,
}) => {
  useEffect(() => {
    sendSearchResultAppearance({ status: 'success' });
  }, [sendSearchResultAppearance]);

  return (
    <GamesGridStatic
      games={games}
      loading={loading}
      onDemoClick={(game) => handleSearchGameClick(game, 'search_results')}
      onPlayClick={(game) => handleSearchGameClick(game, 'search_results')}
      onShowMoreButtonClick={handleClickShowMore}
      perChunkObj={perGamesGridChunk(totalCount || 0)}
      totalCount={totalCount}
      {...gridOptions}
    />
  );
};
